import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { getResourceState } from "../redux/slices/resourceSlice";

const useResources = (id) => {
  const clients = useSelector((state) => getResourceState(state, "client"));

  const vendors = useSelector((state) => getResourceState(state, "vendor"));

  const remarks = useSelector((state) =>
    getResourceState(state, "remark")
  ).results;

  const deliveryTerms = useSelector((state) =>
    getResourceState(state, "delivery-terms")
  ).results;

  const states = useSelector((state) =>
    getResourceState(state, "state")
  ).results;

  const statuses = useSelector((state) =>
    getResourceState(state, "status")
  ).results;

  const vessels = useSelector((state) =>
    getResourceState(state, "vessel")
  ).results;

  const currencies = useSelector((state) =>
    getResourceState(state, "currency")
  ).results;

  const vesselSystems = useSelector((state) =>
    getResourceState(state, "vessel-system")
  ).results;

  const employees = useSelector((state) =>
    getResourceState(state, "employee")
  ).results;

  const clientEmployees = useSelector((state) =>
    getResourceState(state, "client-employee")
  ).results;

  const addresses = useSelector((state) =>
    getResourceState(state, "address")
  ).results;

  const banks = useSelector((state) => getResourceState(state, "bank")).results;

  // From search-details

  const tradeCases = useSelector((state) =>
    getResourceState(state, "trade_cases")
  );

  const enquiries = useSelector((state) =>
    getResourceState(state, "enquiries")
  );
  const quotations = useSelector((state) =>
    getResourceState(state, "quotations")
  );

  const purchase_orders = useSelector((state) =>
    getResourceState(state, "purchase_orders")
  );
  const order_acknowledgments = useSelector((state) =>
    getResourceState(state, "order_acknowledgments")
  );

  const packing_lists = useSelector((state) =>
    getResourceState(state, "packing_lists")
  );

  const proforma_invoices = useSelector((state) =>
    getResourceState(state, "proforma_invoices")
  );

  const invoices = useSelector((state) => getResourceState(state, "invoices"));

  const lineItems = useSelector((state) =>
    getResourceState(state, "line_items")
  );

  const vendorInvoices = useSelector((state) =>
    getResourceState(state, "vendor_invoices")
  );

  const invoicePayments = useSelector(
    (state) => getResourceState(state, "invoice-payments").results
  );

  const clientVessels = useSelector((state) =>
    getResourceState(state, "vessels")
  );

  const vendorInvoicesPaymentsRedux = useSelector((state) =>
    getResourceState(state, "vendor_invoices_payments")
  );
  const vendorInvoicesPayments = !isEmpty(vendorInvoicesPaymentsRedux)
    ? vendorInvoicesPaymentsRedux.filter((vi) => vi.vendor_invoice_id === id)
    : [];

  const clientPageEmployees = useSelector((state) =>
    getResourceState(state, "employees")
  );

  const vendorsByType = useSelector((state) =>
    getResourceState(state, "vendorsByType")
  );

  return {
    clients,
    states,
    statuses,
    vendors,
    addresses,
    banks,
    currencies,
    clientEmployees,
    tradeCases,
    vesselSystems,
    vessels,
    employees,
    enquiries,
    quotations,
    purchase_orders,
    order_acknowledgments,
    packing_lists,
    proforma_invoices,
    invoices,
    lineItems,
    invoicePayments,
    vendorInvoices,
    vendorInvoicesPayments,
    clientVessels,
    remarks,
    deliveryTerms,
    clientPageEmployees,
    vendorsByType,
  };
};

export default useResources;
